<p-menu #optionsMenu [model]="menuItems" [popup]="true" appendTo="body" />
<p-table
  [value]="rows()"
  [columns]="columns()"
  [loading]="loading()"
  [showLoader]="rows().length > 0"
  dataKey="id"
  size="small"
  [rowHover]="true"
  [scrollable]="true"
  styleClass="p-datatable-sm w-full"
  [tableStyle]="{ 'min-width': '100%', width: 'max-content' }"
  [paginator]="paginator()"
  [rows]="rowsPerPage()"
  [lazy]="lazy()"
  [totalRecords]="lazy() ? totalRecords() : rows().length"
  [first]="lazy() ? first() : 0"
  (onPage)="onPage($event)"
  [showFirstLastIcon]="false"
  [showCurrentPageReport]="paginator()"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
  paginatorPosition="bottom"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (col of columns; track col.key) {
        <th class="text-center py-2">{{ col.header }}</th>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-columns="columns">
    <tr>
      @for (col of columns; track col.key) {
        <td class="text-center py-1">
          @switch (col.key) {
            @case ('opciones') {
              @if (!row.sinMenu) {
                <p-button
                  icon="pi pi-ellipsis-v"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  ariaLabel="Opciones"
                  (onClick)="openOptions($event, row)"
                />
              }
            }
            @case ('nombre') {
              <div class="flex align-items-center justify-content-center gap-2">
                <p-avatar
                  [label]="row.iniciales"
                  shape="circle"
                  [style]="row.avatarStyle"
                  [ariaLabel]="row.nombreCompleto"
                />
                <a [routerLink]="['/perfil', row.id]" class="font-semibold text-color no-underline">{{ row.nombreCompleto }}</a>
                @if (row.esLider) {
                  <p-tag value="Líder" [rounded]="true" [style]="roleTagStyle" />
                }
                @if (row.esAdmin) {
                  <p-tag value="Admin" [rounded]="true" [style]="roleTagStyle" />
                }
                @if (row.esContador) {
                  <p-tag value="Contador" [rounded]="true" [style]="roleTagStyle" />
                }
              </div>
            }
            @case ('edad') {
              {{ row.nacimiento | edad }}
            }
            @case ('lider') {
              {{ mostrarPalabras(row.miLider) }}
            }
            @case ('celular') {
              @if (row.whatsappUrl) {
                <a [href]="row.whatsappUrl" target="_blank" rel="noopener noreferrer">{{ row.celular }}</a>
              } @else {
                {{ row.celular || '—' }}
              }
            }
            @case ('cumpleEn') {
              {{ row.cumpleEnLabel }}
            }
            @case ('localidad') {
              {{ mostrarPalabras(row.ciudad) }}
            }
            @case ('motivo') {
              {{ row.motivoLabel }}
            }
            @case ('faltas') {
              {{ row.faltasLabel }}
            }
            @case ('estado') {
              {{ row.estadoLabel }}
            }
            @case ('reunion') {
              {{ row.reunionLabel }}
            }
          }
        </td>
      }
    </tr>
  </ng-template>

  <ng-template pTemplate="loadingbody">
    @if (rows().length === 0) {
      @for (item of skeletonRows; track item) {
        <tr>
          @for (col of columns(); track col.key) {
            <td class="py-2 px-2">
              <p-skeleton height="1rem" />
            </td>
          }
        </tr>
      }
    }
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns().length || 1" class="text-center p-3 text-color-secondary">{{ emptyMessage() }}</td>
    </tr>
  </ng-template>
</p-table>
